<template>
  <div v-if="crumbs.length" class="overflow-auto bg-gray">
    <div
      class="title container flex min-h-[48px] items-center gap-2 whitespace-nowrap py-2 text-xs uppercase leading-none tracking-[0.12em] text-slate"
    >
      <div
        v-for="(item, i) in crumbs"
        :key="i"
        :class="{
          'opacity-50': isLast(i),
          'hidden md:block': isLast(i) && hideLastCrumb,
        }"
      >
        <span v-if="i > 0">/ </span>

        <NuxtLink v-if="item.link" :to="localePath(item.link)">
          {{ $t(item.text) }}
        </NuxtLink>

        <span v-else>
          {{ $t(item.text) }}
        </span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  crumbs?: any[];
}

const props = withDefaults(defineProps<Props>(), {
  crumbs: () => [],
});

const localePath = useLocalePath();

const hideLastCrumb = computed(() => Number(props.crumbs?.length) > 2);
const isLast = (i: number) => i === Number(props.crumbs?.length) - 1;
</script>
